import { colors } from 'styles/theme/colors';

export default function LinkIcon({
  width = 8,
  height = 8,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement> & { color?: string }) {
  return (
    <svg width={width} height={height} viewBox='0 0 9 9' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1.855 4.49716L1.04625 5.3086C0.696149 5.65946 0.49967 6.13498 0.5 6.63065C0.500331 7.12631 0.697445 7.60157 1.04802 7.95196C1.22165 8.1257 1.42782 8.26353 1.65474 8.35757C1.88166 8.4516 2.12488 8.5 2.37051 8.5C2.61613 8.5 2.85936 8.4516 3.08627 8.35757C3.31319 8.26353 3.51936 8.1257 3.69299 7.95196L4.50174 7.14316'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.14685 4.49943L7.95287 3.69512C8.68482 2.9649 8.68482 1.77961 7.95463 1.04851C7.60411 0.697628 7.12859 0.500331 6.63264 0.5C6.13669 0.49967 5.66091 0.696332 5.30992 1.04674L4.50214 1.85369'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M3.36902 5.63044L5.63169 3.36765' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
